import { ROOT_STATUS } from '.';

export const TYPES = {
  BUSINESS_PAY: 'BUSINESS_PAY',
  CANDIDATE_PAY: 'CANDIDATE_PAY',
};

export const TYPES_DISPLAY = {
  BUSINESS_PAY: 'Business pay for the assessment',
  CANDIDATE_PAY: 'Candidate pay for the assessment',
};

export const TYPES_LABEL = {
  BUSINESS_PAY: 'Business Pay',
  CANDIDATE_PAY: 'Candidate Pay',
};

export const STATUSES = {
  ...ROOT_STATUS,
  STATUS_CREATED: {
    key: 'STATUS_CREATED',
    value: 'Created',
    color: 'secondary',
    icon: '',
  },
  STATUS_AWAIT_PAYMENT: {
    key: 'STATUS_AWAIT_PAYMENT',
    value: 'Awaiting Payment',
    color: 'warning',
    icon: '',
  },
  STATUS_PAID: {
    key: 'STATUS_PAID',
    value: 'Paid',
    color: 'secondary',
    icon: '',
  },
  STATUS_PROCESSING: {
    key: 'STATUS_PROCESSING',
    value: 'Processing',
    color: 'secondary',
    icon: '',
  },
  STATUS_FAILED_IN_PROCESSING: {
    key: 'STATUS_FAILED_IN_PROCESSING',
    value: 'Failed in Processing',
    color: 'error',
    icon: '',
  },
  STATUS_ONGOING: {
    key: 'STATUS_ONGOING',
    value: 'Ongoing',
    color: 'primary',
    icon: '',
  },
  STATUS_COMPLETED: {
    key: 'STATUS_COMPLETED',
    value: 'Completed',
    color: 'success',
    icon: '',
  },
  STATUS_CANCELLED: {
    key: 'STATUS_CANCELLED',
    value: 'Cancelled',
    color: 'error',
    icon: '',
  },
};

export const PAYMENT_METHODS = {
  INVOICE: {
    key: 'INVOICE',
    label: 'Invoice',
  },
  UPFRONT_PAYMENT: {
    key: 'UPFRONT_PAYMENT',
    label: 'Credits',
  },
};

export const BOOKING_PURPOSES = {
  PURPOSE_PRE_EMPLOYMENT: {
    key: 'PURPOSE_PRE_EMPLOYMENT',
    label: 'Recruitment',
    description: "Use Quescreen to determine a candidate's suitability",
  },
  PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE: {
    key: 'PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE',
    label: 'General health check',
    description:
      'Use Quescreen to determine the best way to support your staff. Health check results are available to the employee only',
  },
  PURPOSE_RETURN_TO_WORK: {
    key: 'PURPOSE_RETURN_TO_WORK',
    label: 'Return to work scenario',
    description:
      'Use Quescreen to determine the best approach to manage a RTW scenario',
  },
};
